"use client";

import React from "react";
import WiderTalkHeading from "./WiderTalkHeading";
import FeedsList from "../layout/EventList";

interface EventsSectionProps {
  title: string;
  userType: "viewers" | "commentators";
  showBetaBadge?: boolean;
}

const EventsSection: React.FC<EventsSectionProps> = ({
  title,
  userType,
  showBetaBadge = true
}) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 md:p-8">
      <div className="flex items-center justify-between mb-6">
        <WiderTalkHeading>{title}</WiderTalkHeading>
        {showBetaBadge && (
          <span className="text-sm bg-gradient-to-r from-purple-500 to-pink-500 text-transparent bg-clip-text font-semibold">
            BETA
          </span>
        )}
      </div>
      <FeedsList userType={userType} />
    </div>
  );
};

export default EventsSection;
